import { Component, Input, OnInit } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { UserVO } from '../../../generate/UserVO';
import {ChangeRequestService} from "../../../services/change-request.service";

@Component({
    selector: 'lib-user-invite-action',
    templateUrl: './user-invite-action.component.html',
    styleUrls: ['./user-invite-action.component.css'],
    standalone: false
})
export class UserInviteActionComponent implements OnInit {

  @Input()
  usersToInvite: Array<UserVO>;

  randomNewUsersID: string;
  userToInvite: UserVO;

  constructor(private ngxSmartModalService: NgxSmartModalService, private changeRequestService: ChangeRequestService) { }

  ngOnInit(): void {
    this.randomNewUsersID = Math.random().toString(36).substring(7);
  }

  resendInvite() {
    this.userToInvite = this.usersToInvite[0];
    this.ngxSmartModalService.getModal(this.randomNewUsersID).open();
  }

  confirmResendInvite() {
    this.changeRequestService
    .resendUserInvitation(this.userToInvite.id, this.userToInvite.email)
    .subscribe(_ => {}, error => {}, () => {
      this.ngxSmartModalService.getModal(this.randomNewUsersID).close();
    });
  }

  close() {
    this.ngxSmartModalService.close(this.randomNewUsersID);
  }
}
